// extracted by mini-css-extract-plugin
module.exports = {"heading4":"globalStyles_heading4__3LhIw","bodyRegularSmall":"globalStyles_bodyRegularSmall__qcbbk"};